import React from 'react';
import { arrayOf, number, shape, string } from 'prop-types';

import { useStyle } from '@magento/venia-ui/lib/classify';
import Select from '../Select';
import mockData from './mockData';
import defaultClasses from './quantity.module.css';

const Quantity = props => {
    const { classes: propClasses, selectLabel, ...restProps } = props;
    const classes = useStyle(defaultClasses, propClasses);

    return (
        <div className={classes.root}>
            <Select
                {...restProps}
                field="quantity"
                aria-label={selectLabel}
                items={mockData}
            />
        </div>
    );
};
Quantity.propTypes = {
    classes: shape({
        root: string
    }),
    items: arrayOf(
        shape({
            value: number
        })
    )
};

Quantity.defaultProps = {
    selectLabel: "product's quantity"
};

export default Quantity;
